/** Mirrors backend `LeadAttachmentKind` — kept local to avoid stale Vite dep-cache on api-client enums. */
export const LeadAttachmentKind = {
  IMAGE: 'image',
  DOCUMENT: 'document',
  BUSINESS_CARD: 'business_card',
} as const;

export type LeadAttachmentKindValue =
  (typeof LeadAttachmentKind)[keyof typeof LeadAttachmentKind];
